<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-button fill="none" (click)="manager.Navi.openMenu()" slot="start">
      <ion-icon slot="icon-only" name="menu" color="primary"></ion-icon>
    </ion-button>
    <ion-text color="secondary" class="ion-text-center">{{manager.Trad.Parse(Title)}}</ion-text>
    <ion-card
      class="profileCercle profile{{manager.Usr.isLoged && manager.Ws.isConnected? 'Loged':'Anonyme'}} {{ manager.Ws.isConnected && !manager.Usr.isLoged? 'invisible':''}}"
      (click)="manager.Navi.openProfile()" slot="end" color="{{manager.Usr.isLoged? 'primary':'secondary'}}">
      <div *ngIf="manager.Usr.isLoged && manager.Ws.isConnected" style="color: var(--ion-color-primary-contrast)">
        {{manager.Usr.ShortName}}</div>
      <ion-icon class="flashing-element" *ngIf="!manager.Ws.isConnected" name="wifi-outline" color="danger"></ion-icon>
    </ion-card>
  </ion-toolbar>
  <ion-item *ngIf="!manager.Usr.isLoged && !manager.Navi.isSelected('welcome');" class="StatusHeader" lines="none">
    <ion-label>{{manager.Trad.Parse("STR_ANONYMOUS_MODE")}}</ion-label>
  </ion-item>
</ion-header>